import React from 'react'
import PropTypes from 'prop-types'
import glyph from './instagram_glyph.png'

// the props are initialized with default values to enable testing, to save us from mocking process.env
const Instagram = ({ clientId, scope, windowLocation }) => {
  const redirectUri = `${windowLocation.protocol}//${windowLocation.host}/auth/instagram`

  const instagramAuthUrl = `https://api.instagram.com/oauth/authorize/?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}`

  return (
    <div>
      <div className='row'>
        <div className='col-xs-2 col-sm-1 glyph-container'>
          <div className='glyph'>
            <img src={glyph} alt='Instagram' width={40} />
          </div>
        </div>
        <div className='col-xs-10 col-sm-6 col-lg-4'>
          <span className='title'>Instagram</span>
          <span className='description'> by Instagram, Inc.</span>
          <br />
          <span className='description'>
            Blue Robot will require read and write permissions from your
            Instagram account.
          </span>
        </div>
      </div>
      <div className='row' style={{ paddingTop: '25px' }}>
        <div className='col-xs-6 col-sm-5 col-sm-offset-1'>
          <a href={instagramAuthUrl} className='btn blue'>
            Connect to Instagram
          </a>
        </div>
      </div>
    </div>
  )
}

Instagram.displayName = 'Instagram'

Instagram.propTypes = {
  clientId: PropTypes.string,
  scope: PropTypes.string,
  windowLocation: PropTypes.shape({
    host: PropTypes.string,
    protocol: PropTypes.string
  })
}

Instagram.defaultProps = {
  clientId: process.env.REACT_APP_INSTAGRAM_CLIENT_ID,
  scope: process.env.REACT_APP_INSTAGRAM_SCOPE || 'public_content',
  windowLocation: window.location
}

export default Instagram



// WEBPACK FOOTER //
// ./src/pages/profile-settings/social/instagram/index.js